import { useContext } from "react";
import { FileLayoutMaintenancePageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(
    FileLayoutMaintenancePageContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
